function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M63.148.493L50 22.608l-.016 6.003 5.666 3.503 3.916 2.117h2.524l3.915-2.117 18.187-30.59A1.008 1.008 0 0083.325 0h-19.31c-.357 0-.686.187-.867.493z",
  fill: "#C61926"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.648 32.114l2.158 3.629h6.04l2.158-3.63H55.648z",
  fill: "#AD1729"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M55.65 34.23H37.909l-3.916-2.116-18.186-30.59C15.407.85 15.892 0 16.674 0h19.31c.356 0 .685.187.867.493l18.799 31.62v2.117z",
  fill: "#FF4755"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.992 32.114l2.158 3.629h21.656l-2.157-3.63H33.992z",
  fill: "#FC2B3A"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M60.844 42.175h-21.69a5.521 5.521 0 01-5.521-5.521v-.912h32.733v.912a5.521 5.521 0 01-5.522 5.52z",
  fill: "#FFE27A"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.845 40.304h-21.69a5.522 5.522 0 01-5.437-4.561h-.085v2.669a5.521 5.521 0 005.52 5.521h21.691a5.521 5.521 0 005.522-5.521v-2.67h-.085a5.521 5.521 0 01-5.436 4.562z",
  fill: "#F9CF58"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M50 97.673c-27.976 0-28.014-26.921-27.976-27.521C22.959 55.515 35.127 43.933 50 43.933s27.04 11.582 27.976 26.219c.038.6 0 27.521-27.976 27.521z",
  fill: "#FFCB5B"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M49.998 96.371c-14.872 0-27.038-11.582-27.973-26.22-.038.601-.06 1.206-.06 1.815C21.965 87.45 34.515 100 49.998 100s28.034-12.55 28.034-28.034c0-.61-.022-1.214-.06-1.814-.936 14.637-13.101 26.219-27.974 26.219z",
  fill: "#F7B737"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M49.998 90.464c-21.07 0-21.044-19.714-20.993-20.312.92-10.788 9.968-19.256 20.993-19.256 10.91 0 19.883 8.291 20.962 18.916.072.709-.145 20.652-20.962 20.652z",
  fill: "#FF9838"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M49.998 89.408c-11.025 0-20.071-8.469-20.992-19.256a21.39 21.39 0 00-.078 1.814c0 11.637 9.433 21.07 21.07 21.07s21.07-9.433 21.07-21.07c0-.611-.027-1.216-.078-1.814-.92 10.787-9.966 19.256-20.992 19.256z",
  fill: "#FF8709"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M51.992 60.111l2.03 4.114c.324.656.95 1.11 1.673 1.216l4.54.66c1.823.264 2.55 2.504 1.232 3.79l-3.285 3.202a2.222 2.222 0 00-.64 1.967l.776 4.521c.025.145.034.426.034.426h-3.258l-5.095-2.519-5.095 2.52h-3.258s.009-.281.034-.426l.775-4.522a2.222 2.222 0 00-.64-1.967l-3.284-3.202c-1.319-1.286-.591-3.526 1.232-3.79l4.54-.66a2.222 2.222 0 001.673-1.216l2.03-4.114c.815-1.651 3.17-1.651 3.986 0z",
  fill: "#FFF5F5"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M49.53 75.864l-7.882 4.144c.025 1.596 1.757 2.705 3.257 1.917l4.06-2.135c.648-.34 1.421-.34 2.069 0l4.06 2.135c1.5.788 3.232-.321 3.257-1.917l-7.882-4.144a1.007 1.007 0 00-.938 0z",
  fill: "#EFE2DD"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M69.306 37.255h-38.61a1.512 1.512 0 110-3.025h38.61a1.512 1.512 0 110 3.025z",
  fill: "#FF9838"
});
function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
export default SvgMedal;